import { v4 as uuidv4 } from 'uuid';

import {
  DesktopOutlined,
  PieChartOutlined,
  TeamOutlined,
  SettingOutlined
 
} from '@ant-design/icons';

const sideNav = [
  {
    id: uuidv4(),
    label: 'dashboard',
    icon: <DesktopOutlined />,
    path: '/',
    roles: ['admin','devuser','desuser', 'prouser', 'visitor']
  },
  {
    id: uuidv4(),
    label: 'development',
    icon: <PieChartOutlined />,
    path: '/development',
    roles: ['admin','devuser', 'prouser', 'visitor']
  },
  {
    id: uuidv4(),
    label: 'design',
    icon: <TeamOutlined/>,
    path: '/design',
    roles: ['admin','desuser', 'prouser', 'visitor']
  },
  {
    id: uuidv4(),
    label: 'settings',
    icon: <SettingOutlined/>,
    path: '/settings',
    roles: ['admin','desuser', 'prouser', 'visitor']
  },
];
const topNav = [
  {
    id: uuidv4(),
    label: 'profile',
    icon: '',
    path: '/profile',
    roles: ['admin','devuser','desuser', 'prouser', 'visitor']
  },
  {
    id: uuidv4(),
    label: 'certifications',
    icon: '',
    path: '/certifications',
    roles: ['admin','devuser','desuser', 'prouser', 'visitor']
  },
  {
    id: uuidv4(),
    label: 'media',
    icon: '',
    path: '/media',
    roles: ['admin','devuser','desuser', 'prouser', 'visitor']
  },
  {
    id: uuidv4(),
    label: 'blog',
    icon: '',
    path: '/blog',
    roles: ['admin', 'prouser', 'visitor']
  },
  {
    id: uuidv4(),
    label: 'account',
    icon: '',
    path: '/account',
    roles: ['root']
  },
  {
    id: uuidv4(),
    label: 'documentation',
    icon: '',
    path: '/documentation',
    roles: ['root','admin','devuser','desuser', 'prouser', 'visitor']
  },
  
];

export { sideNav, topNav };
